import * as React from "react";
import DateTemplate from "../../../ui/templates/columns/DateTemplate";
import NameTemplate from "../../../ui/templates/columns/NameTemplate";
import PriorityTemplate from "../../../ui/templates/columns/PriorityTemplate";
import ValueTemplate from "../../../ui/templates/columns/ValueTemplate";
import PrwcDataTableBasic from "../../../ui/widgets/custom/PrwcDataTableBasic";

const ProfileAttributes = (props: any) => {

  const data = [
    {
      id: 1,
      name: "Attribute 1",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 1,
    },
    {
      id: 2,
      name: "Attribute 2",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 2,
    },
    {
      id: 3,
      name: "Attribute 3",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 3,
    },
    {
      id: 4,
      name: "Attribute 4",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 1,
    },
    {
      id: 5,
      name: "Attribute 5",
      value: "value 1",
      validFrom: "3/12/2020",
      validTo: "14/2/2020",
      priority: 2,
    },
  ];

  const dataTable = {
    columns: [
      {
        field: "attribute",
        headerLabelKey: "users.label.attribute",
        bodyTemplate: NameTemplate,
        templateArgument: "name",
        className: "w-14 text-xs font-semibold text-blue-700",
      },
      {
        field: "value",
        headerLabelKey: "users.label.value",
        bodyTemplate: ValueTemplate,
        templateArgument: "name",
        className: "w-14 text-xs",
      },
      {
        field: "validFrom",
        headerLabelKey: "users.label.validFrom",
        bodyTemplate: DateTemplate,
        className: "w-14 text-xs",
      },
      {
        field: "validTo",
        headerLabelKey: "users.label.validTo",
        bodyTemplate: DateTemplate,
        className: "w-14 text-xs",
      },
      {
        field: "priority",
        headerLabelKey: "users.label.priority",
        bodyTemplate: PriorityTemplate,
        className: "w-14 text-xs",
      },
    ],
  };

  return (
      <>
        <PrwcDataTableBasic
          data={data}
          columns={dataTable.columns}
        ></PrwcDataTableBasic>
      </>
  );
};

export default ProfileAttributes;
